const emitir_folha_de_rosto = [
  {
    path: "/emitir-folha-de-rosto",
    name: "emitir_folha_de_rosto",
    meta: {
      allowedPermissions: ["atasfinais_folha_rosto"],
      breadCrumb: "Processo de Resultado Final - Encerramento do Ano Letivo",
    },
    component: () =>
      import("@/views/EmitirFolhaDeRosto/EmitirFolhaDeRosto.vue"),
  },
];

export { emitir_folha_de_rosto };
